export default __webpack_public_path__ + "static/smellsLikeChamomile-76f45ec0c4b75b79703a09fb7d38a943.png";